
"use client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useI18n } from '@/lib/I18nProvider';

import {
    faChevronDown,
} from "@fortawesome/free-solid-svg-icons";

export default function Navbar({ data }) {
    const { locale, setLocale, t } = useI18n();

    const languageTrigger =
        locale === 'fr' ? 'FR' : 'EN';

    return (
    <nav className="navbar has-shadow" role="navigation" style={{backgroundColor: data.primary_color ?? 'white'}}>
        <div className="container section-small" style={{display: 'block'}}>
            <div className="columns is-centered m-0">
                <div className="column is-10-tablet is-8-desktop p-0">

                    <div className="columns is-mobile m-0 is-vcentered">
                        <div className="column p-0">
                            <a className="" href="https://www.onship.ca/">
                            {
                                data.logo ? (
                                    <img src={data.logo} style={{maxHeight: 40, marginBottom: '-0.5em'}} alt="" />
                                ) : null
                            }
                            </a>
                        </div>

                        <div className="column p-0 is-8-mobile has-text-right">
                            <div className="is-flex is-justify-content-flex-end" style={{ gap: '0.5rem', flexWrap: 'wrap' }}>
                            <div className="dropdown is-right is-hoverable">
                                <div className="dropdown-trigger">
                                    <button className="button" type="button" aria-haspopup="true" aria-controls="dropdown-menu-help">
                                        <span>{t('clientPortal.navbar.help')}</span>
                                        <span className="icon is-small has-text-primary">
                                            <FontAwesomeIcon
                                                icon={faChevronDown}
                                            />
                                        </span>
                                    </button>
                                </div>
                                <div className="dropdown-menu" id="dropdown-menu-help" role="menu">
                                    <div className="dropdown-content">
                                        <div className="dropdown-item">
                                            <p>
                                            {t('clientPortal.navbar.helpIntro')}{' '}
                                            {t('clientPortal.navbar.helpCallLabel')}{' '}
                                            <strong>{data.phone}</strong>{' '}
                                            {t('clientPortal.navbar.helpEmailLabel')}{' '}
                                            <strong>{data.email}</strong>.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="dropdown is-right is-hoverable">
                                <div className="dropdown-trigger">
                                    <button
                                        className="button"
                                        type="button"
                                        aria-haspopup="true"
                                        aria-controls="dropdown-menu-lang"
                                        aria-label={t('clientPortal.navbar.languageMenu')}
                                    >
                                        <span>{languageTrigger}</span>
                                        <span className="icon is-small has-text-primary">
                                            <FontAwesomeIcon icon={faChevronDown} />
                                        </span>
                                    </button>
                                </div>
                                <div className="dropdown-menu" id="dropdown-menu-lang" role="menu">
                                    <div className="dropdown-content">
                                        <a
                                            href="#"
                                            className="dropdown-item"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setLocale('fr');
                                            }}
                                        >
                                            {t('languageSelect.french')} (FR)
                                        </a>
                                        <a
                                            href="#"
                                            className="dropdown-item"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setLocale('en');
                                            }}
                                        >
                                            {t('languageSelect.english')} (EN)
                                        </a>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </nav>
  )
}
